export default function BeatGridPositionUpdateAction(actionContext, payload) {
	return actionContext.dispatch('BEAT_GRID_UPDATE_POSITION', payload);
}